import Swiper, {Pagination, Navigation, Autoplay} from 'swiper';
Swiper.use([Pagination, Navigation, Autoplay]);

export namespace RoyalTVSlider {
	let stopAllVideos = () => {
		let iframes = document.querySelectorAll('.rtv-slide-card__iframe');
		iframes.forEach((iframe) => {
			let originalSrc = iframe.getAttribute('src');
			iframe.setAttribute('src', originalSrc);
		});
	};

	let setupSlider = () => {
		let rtvSliders = document.querySelectorAll('.js-rtv-slider');

		//For Each Hero Slider Loop through and setup swiper
		rtvSliders.forEach((slider, index) => {
			let promises = [];
			let links = slider.querySelectorAll('.js-rtv-play');
			let modalLinks = slider.querySelectorAll('.rtv-slider__slide .js-rtv-grid-play');
			links.forEach((link) => {
				let linkYoutubeID = link.getAttribute('data-youtubeid');
				let coverImagePath = link.querySelector('.rtv-slider-card__image').getAttribute('src');
				promises.push(new Promise((resolve) => {
					let img = new Image();
					img.onload = resolve;
					img.src = coverImagePath;
				}));

				link.addEventListener('click', (e) => {
					let coverImage = link.querySelector('.rtv-slider-card__cover-image');
					let playIcon = link.querySelector('.rtv-slider-card__play');
					if (modalLinks.length == 0) {
						coverImage.classList.add('state-hidden');
						playIcon.classList.add('state-hidden');
					}					
					e.preventDefault();
				});
			});

			slider.classList.add(`rtv-slider__swiper--${index}`);
			const swiper = new Swiper(`.rtv-slider__swiper--${index}`, {
				slidesPerView: 3,
				slideActiveClass: "slide-active",
				spaceBetween: 0,
				slideToClickedSlide: true,
				initialSlide: 0,// second item is the starting slide

				breakpoints: {
					0: {
						slidesPerView: 1,
						spaceBetween: 0,
						initialSlide: 0
					},
					768: {
						slidesPerView: 3,
						spaceBetween: 20,
						initialSlide: 0,
					}
				},

				navigation: {
					nextEl: `.rtv-slider__swiper--${index} .swiper-button-next`,
					prevEl: `.rtv-slider__swiper--${index} .swiper-button-prev`,
				},

				on: {
					slideChange: function () {
						links.forEach((link) => {
							let coverImage = link.querySelector('.rtv-slider-card__cover-image');
							let playIcon = link.querySelector('.rtv-slider-card__play');
							coverImage.classList.remove('state-hidden');
							playIcon.classList.remove('state-hidden');
							stopAllVideos();
						});
					}
				}
			});

			Promise.all(promises).then((values) => {
				slider.classList.add('state-visible');
			});;

		});
	}

	export const init = () => {
		setupSlider();
	}
}

document.addEventListener('DOMContentLoaded', RoyalTVSlider.init);
